import { Dispatch, SetStateAction } from 'react';
import { Notification, Pagination } from '../interfaces';
import { get, post } from '../scripts';
import { API } from '../data/30pay.api';

export const _getNotifications = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Pagination<Notification> | undefined>>,
    page: number,
    pageSize: number,
    query?: string,
) => {
    setLoading(true);
    await get<Pagination<Notification>>(`${API.notification.getMine(page, pageSize)}${query ? query : ''}`).then((response) => {
        setLoading(false);
        setData(response.value.value)
    }).catch((e) => setLoading(false));
};

export const _readNotification = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: { notificationId: string },
    onComplete: () => void
) => {
    setLoading(true);
    await post(API.notification.read, data).then((response) => {
        setLoading(false)
        onComplete()
    }).catch((e) => setLoading(false));
}

export const _getUnreadCount = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    onCount: (n: number) => void
) => {
    setLoading(true);
    try {
        // Request only unread notifications with minimal payload (pageSize=1)
        const res = await get<Pagination<Notification>>(`${API.notification.getMine(1, 10)}?isRead=false`);
        const pagination = res?.value?.value as Pagination<Notification> | undefined;
        const total = (pagination as any)?.pagination?.totalCount ?? 0;
        onCount(total);
    } catch (e) {
        // On failure, fall back to 0 to avoid breaking the UI
        onCount(0);
    } finally {
        setLoading(false);
    }
};